import type { Dest } from '@kdk/shared';
import { DEST_LABEL } from '@kdk/shared';
import { tokens } from '@kdk/shared/theme';
import { Chip } from '@mui/material';

type Props = { dest: Dest | 'x'; label?: string };

export const DestChip = ({ dest, label }: Props) => {
  const color = dest === 'x' ? tokens.dim : tokens.dest[dest];
  const border = dest === 'x' ? tokens.line : `${color}73`;
  const background = dest === 'x' ? 'transparent' : `${color}14`;
  return (
    <Chip
      size="small"
      label={label ?? (dest === 'x' ? '' : DEST_LABEL[dest])}
      sx={{
        height: 'auto',
        py: '1px',
        borderRadius: '4px',
        fontSize: 12,
        color,
        bgcolor: background,
        border: `1px solid ${border}`,
        '& .MuiChip-label': { px: '7px' },
      }}
    />
  );
};
